<template>
    <div id="new-chat-flows-promotions-list" v-if="mariaIsEnabled">

        <div class="mr-12">

            <div>
                <span class="ml-2 font-medium text-sm" style="color: #6c6c6c;">
                    Descrição
                </span>
                <vs-textarea
                    counter="1800"
                    class="vs-textarea text-area"
                    v-model="description"
                />
            </div>

            <div class="float-right mt-6">
                <vs-button @click.stop="infos.length !== 0 ? updateInfos() : createInfos()" :disabled="
                (
                    description.trim() === '' ||
                   !canSee('create')
                )
            ">
                    Salvar
                </vs-button>
            </div>

        </div>

        <br>

        <div class="mt-10">
            <h2 style="color: #6c6c6c;"> Promoções </h2>
        </div>

        <div  v-if="canSee('create')" @click="toggleSidebar(null, 'create')" class="mt-4" style="width: 160px;">

            <div class="p-3 mr-4 rounded-lg cursor-pointer flex items-center text-lg
                font-medium text-base text-primary border border-solid border-primary w-full"
            >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                <span
                    class="ml-2 text-base text-primary"
                >
                    Adicionar Novo
                </span>
            </div>

        </div>

        <vs-table 
            ref="table"
            :data="prompts"
            :sst="true"
            noDataText='Clique em "Adicionar Novo" para criar um novo produto da promoção!'
            style="padding-right: 24px !important;"
        >

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr 
                        :data="tr" 
                        :key="tr.id"
                        :id="tr.id"
                        v-for="(tr, index) in prompts"
                    >

                        <vs-td :title="tr.name" :data="tr.name" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px;">
                            <p class="text-lg font-medium pl-20 truncate-text">
                                {{ tr.name }}
                            </p>
                        </vs-td>

                        <vs-td class="d-flex justify-end">
                            <vs-switch v-if="canSee('edit')" @input="update(index, tr)" v-model="isActiveList[index]" color="success">
                                <span class="text-sm" slot="on">Ativo</span>
                                <span class="text-sm" slot="off">Inativo</span>
                            </vs-switch>
                        </vs-td>

                        <vs-td class="text-center" style="border-top-right-radius: 8px; border-bottom-right-radius: 8px;">
                            <feather-icon
                                @click.stop="toggleSidebar(tr, 'update')"
                                icon="EditIcon"
                                svgClasses="w-5 h-5 hover:text-primary"
                                v-if="canSee('edit')"
                            />

                            <feather-icon
                                @click.stop="toggleDeletePopUp(tr)"
                                icon="TrashIcon"
                                svgClasses="w-5 h-5 hover:text-danger"
                                class="ml-6"
                                v-if="canSee('delete')"
                            />
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>
    
        </vs-table>

        <div class="mt-3 mr-10">
            <vs-pagination
                :total="totalPages"
                v-model="page"
            />
        </div>

        <Sidebar
            :isActive="sidebarIsActive"
            :context="sidebarContext"
            :data="sidebarData"
            @reloadQuery="fetch()"
            @isActiveFalse="sidebarIsActive = false"
        />

        <div>
            <vs-popup title="Remover Produto" :active.sync="deletePopUpIsActive" @close="deletePopUpIsActive = false">
                <p class="text-left">Deseja realmente remover o Produto de nome <strong> {{ dataToDelete.name }} </strong>
                    das opções de promoção do Fluxo Bot de Triagem da Mar.IA ?
                </p> <br>

                <div class="w-full d-flex justify-content-flex-end">
                    <vs-button color="danger" @click.stop="remove()">Remover</vs-button>
                </div>
            </vs-popup>
        </div>

    </div>
</template>

<script>

    import { hasFeature } from '@/utils'
    import Sidebar from './PromotionsSidebar.vue';
    import modulePrompt from '@/store/prompt/modulePrompt';
    import { decodeFromBase64, encodeToBase64, hasPermission } from '@/utils';

    export default {
        data() {
            return {
                page: 1,
                itemsPerPage: 4,
                description: '',
                isActiveList: [],
                mariaIsEnabled: false,
                sidebarIsActive: false,
                sidebarContext: 'create',
                deletePopUpIsActive: false,
                sidebarData: {
                    id: null,
                    key: null,
                    name: null,
                    price: 0.0,
                    prompt_id: null,
                    discont_price: 0.0
                },
                dataToDelete: {
                    id: null,
                    name: null
                }
            }
        },
        methods: {
            async fetch() {
                await this.$store.dispatch("prompt/fetch",
                    {
                        prompt_id: 1,
                        key: '{promotions}',
                        page: this.page,
                        itemsPerPage: this.itemsPerPage
                    }
                );

                this.isActiveList = ( this.prompts !== undefined && this.prompts !== null && this.prompts.length !== 0 ) ?
                    [
                        ...this.prompts.map(
                            item => item.is_active
                        )
                    ]
                    : [];
                
                await this.fetchInfos();
            },
            async fetchInfos() {
                await this.$store.dispatch("prompt/fetchInfos",
                    {
                        prompt_id: 1,
                        key: '{description}',
                    }
                );

                this.setInfos();
            },
            setInfos() {
                const index = this.infos.findIndex( item => item.key === "{description}" );

                index !== - 1 ? ( this.description = decodeFromBase64(this.infos[index].name) ) : '';
            },
            async createInfos() {

                if (this.description.length > 1800) {
                    return this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'O número máximo de caracteres foi atingido!',
                            time: 5000
                        }
                    );
                }

                await this.$store.dispatch("prompt/createInfos",
                    {
                        key: '{description}',
                        name: encodeToBase64(this.description),
                        prompt_id: 1
                    }
                )
                .then(
                    () => {
                        this.setInfos();
                        this.$vs.notify(
                            {
                                color: 'success',
                                title: 'Sucesso!',
                                text: 'Os dados foram criados com Sucesso!',
                                time: 5000
                            }
                        );
                    }
                )
                .catch(
                    () => {
                        this.$vs.notify(
                            {
                                color: 'danger',
                                title: 'Erro!',
                                text: 'Algo deu errado ao criar os dados!',
                                time: 5000
                            }
                        );
                    }
                );

            },
            async updateInfos() {

                if (this.description.length > 1800) {
                    return this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'O número máximo de caracteres foi atingido!',
                            time: 5000
                        }
                    );
                }

                const index = this.infos.findIndex( item => item.key === "{description}" );

                if ( index !== - 1 ) {

                    await this.$store.dispatch("prompt/updateInfos",
                        {
                            id: this.infos[index].id,
                            name: encodeToBase64(this.description)
                        }
                    )
                    .then(
                        () => {
                            this.setInfos();
                            this.$vs.notify(
                                {
                                    color: 'success',
                                    title: 'Sucesso!',
                                    text: 'Os dados foram atualizados com Sucesso!',
                                    time: 5000
                                }
                            );
                        }
                    )
                    .catch(
                        () => {
                            this.$vs.notify(
                                {
                                    color: 'danger',
                                    title: 'Erro!',
                                    text: 'Algo deu errado ao atualizar os dados!',
                                    time: 5000
                                }
                            );
                        }
                    );

                }

            },
            toggleSidebar(data = null, context) {
                if (context === 'update') {
                    this.sidebarData = {
                        ...data
                    };
                }

                this.sidebarContext  = context;
                this.sidebarIsActive = true;
            },
            async update(index, data) {
                await this.$store.dispatch("prompt/update",
                    {
                        id: data.id,
                        name: null,
                        department_id: null,
                        is_active: this.isActiveList[index]
                    }
                )
                .then( () => {
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'O produto foi atualizada com Sucesso!',
                            time: 5000
                        }
                    );
                })
                .catch( () => {
                    this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Algo deu errado ao atualizar o produto!',
                            time: 5000
                        }
                    );
                });
            },
            toggleDeletePopUp(data) {
                this.dataToDelete.id     = data.id;
                this.dataToDelete.name   = data.name;
                this.deletePopUpIsActive = true;
            },
            async remove() {
                await this.$store.dispatch("prompt/delete", this.dataToDelete.id)
                .then( () => {
                    this.deletePopUpIsActive = false;
                    this.dataToDelete        = {
                        id: null,
                        name: null,
                    };

                    this.fetch();
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'O produto foi deletada com Sucesso!',
                            time: 5000
                        }
                    );
                })
                .catch( () => {
                    this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Algo deu errado ao deletar o produto!',
                            time: 5000
                        }
                    );
                });
            },
            canSee(action) {
                return hasPermission(`${this.$route.name}-${action}`)
            }
        },
        computed: {
            prompts() {
                return this.$store.state.prompt.prompts.items || [];
            },
            totalPages() {
                return this.$store.state.prompt
                    && this.$store.state.prompt.prompts.total_pages
                    ? this.$store.state.prompt.prompts.total_pages
                    : 0
            },
            infos() {
                return this.$store.state.prompt.prompts.infos === undefined
                ? [] : this.$store.state.prompt.prompts.infos;
            }
        },
        watch: {
            'page'() {
                this.fetch();
            },
            'itemsPerPage'() {
                this.page = 1;
                this.fetch();
            }
        },
        async created() {
            this.mariaIsEnabled = await hasFeature('maria');

            if (!modulePrompt.isRegistered) {
                this.$store.registerModule('prompt', modulePrompt);
                modulePrompt.isRegistered = true;
            }

            this.fetch();
        },
        components: {
            Sidebar
        },
        beforeRouteLeave(to, from, next) {
            this.deletePopUpIsActive = false;
            this.sidebarIsActive     = false;
            setTimeout( ()=> {
                next();
            }, 2);
        }
    }
</script>

<style lang="scss">

    #new-chat-flows-promotions-list {

        .text-area {
            background: #fff;
            border-radius: 12px;
            border-color: rgba(0, 0, 0, 0.247) !important;
            box-shadow: 2px 4px 5px 0px rgba(31, 29, 29, 0.116) !important;
    
            textarea {
                height: 70px;
            }
        }

        > div:nth-child(1) input {
            height: 42px;
            border-radius: 10px;
            border-color: rgba(0, 0, 0, 0.329) !important;
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 1.0rem;
            padding-right: 1rem;
        }
        tbody > tr {
            height: 40px;
            box-shadow: 2px 4px 20px 0 rgba(0, 0, 0, 0.05);

            td.td.vs-table--td:first-of-type {
                width: 60% !important;
            }
            td.td.vs-table--td:nth-of-type(3) {
                width: 22% !important;
            }
        }

        .truncate-text {
            max-width: 600px;
            overflow: hidden !important;
            white-space: nowrap !important;
            text-overflow: ellipsis !important;
        }
    }

</style>